import { classNames } from "../utils";

type ButtonProps = {
    type?: "button" | "submit" | "reset";
    buttonType?: "primary" | "secondary" | "success" | "danger" | "warning" | "info";
    loading?: boolean;
    disabled?: boolean;
    label?: any;
    className?: string;
    fullWidth?: boolean;
    icon?: JSX.Element;
    [key: string]: any;
    tooltipMsg?: string;
};

export default function Button({
    type = "button",
    buttonType = "primary",
    loading = false,
    disabled = false,
    label,
    fullWidth = false,
    className = "",
    icon,
    tooltipMsg = "",
    ...props
}: ButtonProps) {
    let buttonTypeClass = "";
    switch (buttonType) {
        case "primary":
            buttonTypeClass =
                "text-white bg-primary-500 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500";
            break;
        case "secondary":
            buttonTypeClass =
                "text-white bg-primary-300 hover:bg-primary-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-300";
            break;
        case "success":
            buttonTypeClass =
                "text-white bg-green-600  hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600 ";
            break;
        case "danger":
            buttonTypeClass =
                "text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500";
            break;
        case "warning":
            buttonTypeClass =
                "text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-600";
            break;
        case "info":
            buttonTypeClass =
                "text-white bg-slate-500 hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500";
            break;
        default:
            buttonTypeClass =
                "text-white bg-primary-500 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500";
            break;
    }
    return (
        <button
            disabled={disabled || loading}
            type={type}
            className={classNames(
                className,
                fullWidth ? "w-full" : "",
                "flex justify-center py-2 px-2 border border-transparent rounded-md shadow-sm text-sm font-medium disabled:opacity-75 disabled:cursor-not-allowed",
                buttonTypeClass,
            )}
            {...props}
        >
            <>
                <div className="flex has-tooltip justify-center items-center">
                    {
                        loading && (
                            <svg
                                className='animate-spin -ml-0  h-5 w-4 text-white mr-2'
                                xmlns='http://www.w3.org/2000/svg'
                                fill='none'
                                viewBox='0 0 24 24'
                            >
                                <circle
                                    className='opacity-25'
                                    cx='12'
                                    cy='12'
                                    r='10'
                                    stroke='currentColor'
                                    strokeWidth='4'
                                ></circle>
                                <path
                                    className='opacity-75'
                                    fill='currentColor'
                                    d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                                ></path>
                            </svg>
                        )
                    }
                    {label && label}
                    {
                        tooltipMsg && <span className='tooltip rounded shadow-lg p-1 bg-secondary text-white -mt-10 text-xs -ml-10'>{tooltipMsg}</span>
                    }
                    {icon && icon}
                </div>
            </>
        </button>
    );
}
